<template>
  <ul class="list list-group list-group-horizontal">
    <li
      v-show="keyItem.item.value !== '' && keyItem.key !== 'fetchTypes'"
      class="m-1 list-group-item"
      v-for="keyItem in searchParams"
      :key="keyItem.key"
    >
      <span>
        <img
          v-if="keyItem.key === 'soort' && soortType && keyItem.item.value"
          :src="'/soort/'+soortType.toLowerCase()+'/'+keyItem.item.value + '/icon'"
          width="20"
          height="20"
        />
      </span>
      <span>{{keyItem.item.label}}</span>

      <i @click="removeSearchParam(keyItem.key)" data-v-3c1df6 class="fas fa-window-close closer"></i>
    </li>
  </ul>
</template>
<script>
import { mapGetters, mapActions, mapMutations } from "vuex";
import { CLEAR_SEARCHPARAM } from "../store/action-types";

export default {
  methods: {
    ...mapActions({
      removeSearchParam: CLEAR_SEARCHPARAM,
    }),
  },
  computed: {
    soortType() {
      return this.$store.state.searchParams.type.value || "";
    },
    searchParams() {
      return Object.keys(this.$store.state.searchParams).map((key) => {
        return { key: key, item: this.$store.state.searchParams[key] };
      });
    },
  },
};
</script>
<style scoped>
.list {
  z-index: 2000;
  position: absolute;
  bottom: 20px;
  left: 20px;
}
</style>